import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default from 'react';
import { SortDirections } from './a06c6f76e084627ad63dad72cb6669a0a8dc74141d25c552099ec88774dc0199.cfe-internal.js';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';
import '../629495c61f6f3ffdfe2248a13b452d018cea8d55bb88c94e497bf6f5395fc2fd.cfe-internal.js';
import '../../icons/index.es.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import MenuItem from '../NewMenu/parts/e0e3eb84541b87de3d5450a4a2a9274df211ed818d3168ab6e8a7aeb42987979.cfe-internal.js';
import UnpinIcon from '../../icons/components/628e7da6190228698651fb976fde958090ba9817c7d95a07b006d10c2f14a12f.cfe-internal.js';
import PinIcon from '../../icons/components/8a98ce7a0af5423de83bceb3b2d2ddd611e9c36ae24fbd4117974d24ca269f3e.cfe-internal.js';
import SelectMenu from '../NewMenu/SelectMenu/4a4726afbad82943358c019888e2f68a05e62971887d5ae0ccf6187787bfd671.cfe-internal.js';
import ArrowUpIcon from '../../icons/components/6cb403baa9eba83ceae0c3d67c54298c995135d440dbeec8279880230b799921.cfe-internal.js';
import ArrowDownIcon from '../../icons/components/84327b391aa7f0f9aada905874e525eea5755d08735fe0a7b64af792e65f2e71.cfe-internal.js';
import Divider from '../Divider/fbeb7b1314dbcd7463c9d19a9d22f613b360d9aadf43cd1930539d52bb14fae2.cfe-internal.js';
import ArrowLeftIcon from '../../icons/components/b67e0c9903dde0e28a245de625c4453b49e65d1bd21fdd97f10fe159749a3aa4.cfe-internal.js';
import ArrowRightIcon from '../../icons/components/4d1bba7ff0f238a0cbfc2f31b9e7f5f4f272fd9cde056f004d68e44dee7c53c4.cfe-internal.js';

var _excluded = ["sortOptions", "selectedSortOption", "setSelectedSortOption", "isPinned", "onIsPinnedChange", "onMoveLeft", "onMoveRight", "isOpen", "setIsOpen", "columnId", "columnHeaderRef"];
var AdvancedTableColumnHeaderMenu = function AdvancedTableColumnHeaderMenu(_ref) {
  var sortOptions = _ref.sortOptions,
    selectedSortOption = _ref.selectedSortOption,
    setSelectedSortOption = _ref.setSelectedSortOption,
    isPinned = _ref.isPinned,
    onIsPinnedChange = _ref.onIsPinnedChange,
    onMoveLeft = _ref.onMoveLeft,
    onMoveRight = _ref.onMoveRight,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen,
    columnId = _ref.columnId,
    columnHeaderRef = _ref.columnHeaderRef,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var id = useId();
  var selectedValue = _JSON$stringify(selectedSortOption);
  var getActionMenuItem = function getActionMenuItem(_ref2) {
    var _onSelect = _ref2.onSelect,
      Icon = _ref2.Icon,
      label = _ref2.label;
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      role: "menuitem" // Enables having an action menu item inside of a SelectMenu
      ,
      onSelect: function onSelect(e) {
        var _columnHeaderRef$curr;
        e.preventDefault(); // prevents SelectMenu value from changing
        setIsOpen(false);
        (_columnHeaderRef$curr = columnHeaderRef.current) === null || _columnHeaderRef$curr === void 0 || _columnHeaderRef$curr.focus();
        _onSelect === null || _onSelect === void 0 || _onSelect();
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      size: "small",
      className: styles.advancedTableColumnHeaderMenuItemIcon,
      "aria-hidden": "true"
    }), label);
  };
  var pinItem;
  if (onIsPinnedChange) {
    var pinIcon = isPinned ? UnpinIcon : PinIcon;
    var pinLabel = translate(isPinned ? 'advancedTable.unpinColumn' : 'advancedTable.pinColumn');
    pinItem = getActionMenuItem({
      onSelect: function onSelect() {
        return onIsPinnedChange(!isPinned);
      },
      Icon: pinIcon,
      label: pinLabel
    });
  }
  return /*#__PURE__*/React__default.createElement(SelectMenu, _extends({
    key:
    // A hack since SelectMenu can't be controlled
    selectedSortOption.columnId === columnId ? selectedValue : columnId,
    id: id,
    defaultValue: selectedValue,
    onChange: function onChange(value) {
      setSelectedSortOption(JSON.parse(String(value)));
    },
    isOpen: isOpen,
    onIsOpenChange: setIsOpen
  }, rest), sortOptions === null || sortOptions === void 0 ? void 0 : _mapInstanceProperty(sortOptions).call(sortOptions, function (_ref3, index) {
    var ascendingLabel = _ref3.ascendingLabel,
      ascendingIcon = _ref3.ascendingIcon,
      descendingLabel = _ref3.descendingLabel,
      descendingIcon = _ref3.descendingIcon;
    var ascendingValue = _JSON$stringify({
      columnId: columnId,
      index: index,
      direction: SortDirections.Ascending
    });
    var descendingValue = _JSON$stringify({
      columnId: columnId,
      index: index,
      direction: SortDirections.Descending
    });
    var AscendingIconComponent = ascendingIcon || ArrowUpIcon;
    var DescendingIconComponent = descendingIcon || ArrowDownIcon;
    return [/*#__PURE__*/React__default.createElement(MenuItem, {
      key: ascendingValue,
      value: ascendingValue,
      label: ascendingLabel
    }, /*#__PURE__*/React__default.createElement(AscendingIconComponent, {
      size: "small",
      className: styles.advancedTableColumnHeaderMenuItemIcon,
      "aria-hidden": "true"
    }), ascendingLabel), /*#__PURE__*/React__default.createElement(MenuItem, {
      key: descendingValue,
      value: descendingValue,
      label: descendingLabel
    }, /*#__PURE__*/React__default.createElement(DescendingIconComponent, {
      size: "small",
      className: styles.advancedTableColumnHeaderMenuItemIcon,
      "aria-hidden": "true"
    }), descendingLabel)];
  }), (sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) && (onIsPinnedChange || onMoveLeft || onMoveRight) && /*#__PURE__*/React__default.createElement(Divider, null), pinItem, onMoveLeft && getActionMenuItem({
    onSelect: onMoveLeft,
    Icon: ArrowLeftIcon,
    label: translate('advancedTable.moveColumnLeft')
  }), onMoveRight && getActionMenuItem({
    onSelect: onMoveRight,
    Icon: ArrowRightIcon,
    label: translate('advancedTable.moveColumnRight')
  }));
};

export { AdvancedTableColumnHeaderMenu as default };
